module.exports = __webpack_public_path__ + "img/compny-5.794ec89f.png";